var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-button',{attrs:{"icon":"plus","href":_vm.href}},[_vm._v("\n  Novo alerta\n")])}
var staticRenderFns = []

export { render, staticRenderFns }